import {Directive, ElementRef, Input, OnInit} from '@angular/core';

@Directive({
    selector: '[SkeletonLoader]'
})
export class SkiletonLoaderDirective implements OnInit {

    constructor(private element: ElementRef) {

    }

    ngOnInit() {
        setTimeout(() => {
            const refElement = this.element.nativeElement.getElementsByTagName('span')[0] as HTMLElement;
            refElement.style.marginLeft = 'unset';
            refElement.style.marginTop = 'unset';
            refElement.style.left = 'unset';
            refElement.style.top = 'unset';
            refElement.style.margin = 'unset';

        });

    }

}
